// export const DOMAIN = "http://localhost:4000"; // hoặc domain thật
// export const DOMAIN = "https://api.elephant.bro.kakiem.xyz"; //3y
// export const DOMAIN = "https://api.elephant.nam.kakiem.xyz"; //2
// export const DOMAIN = "https://api.elephant.kakiem.xyz"; //1
export const DOMAIN = "https://api.old.kakiem.xyz"; //0


export const DOMAIN_FB = `${DOMAIN}/api/fb/`;